import React, { useEffect, useState } from 'react';
import Card from "@mui/material/Card";
import Paginations from "../../common/pagination/Paginations";
import { handleContactedPersonApi } from '../../api';
import { useSelector } from 'react-redux';
import { AdminTable } from '../../common/adminTable';

const UserContactedList = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const [contactedData, setContactedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const allContactedList = async () => {
    try {
      setLoading(true);
      const response = await handleContactedPersonApi({ token, currentPage });
      setContactedData(response?.contacts || []);
      setCurrentPage(parseInt(response?.currentPage));
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    allContactedList();
  }, [currentPage]);

  const columns = [
    { field: "name", headerName: "Name", minWidth: 130, renderCell: (r) => r.name || "-" },
    { field: "email", headerName: "Email", minWidth: 160, renderCell: (r) => r.email || "-" },
    { field: "phone", headerName: "Phone No", width: 130, renderCell: (r) => r.phone || "-" },
    {
      field: "message",
      headerName: "Message",
      minWidth: 200,
      cellSx: { maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
      renderCell: (r) => r.message || "-",
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 120,
      cellSx: { whiteSpace: "nowrap" },
      renderCell: (r) =>
        new Date(r.createdAt || "").toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }),
    },
  ];

  return (
    <Card sx={{ padding: "20px", borderRadius: "25px", marginTop: "40px", marginBottom: "30px" }}>
      <AdminTable
        columns={columns}
        rows={contactedData}
        loading={loading}
        rowKey="_id"
        emptyText="No contacts found"
      />
      <Paginations
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        disabled={loading}
      />
    </Card>
  );
};

export default UserContactedList;
